import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class AgentTypeMultipleSelectSectionComponent implements IController {
  types: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;

  /* @ngInject */
  constructor(private agentConstants) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.agentConstants.types;
    }
  }

  $onChanges(changes) {
    if (changes.types) {
      this.selectedKeys = [];
      _.forEach(this.types, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      types: isSelected ? _.concat(this.types, [option]) :
        _.filter(this.types, (type) => {
          return type !== option;
        })
    });
  }


  submitQuery(query) {
    this.queryString = query;
  }

  onReset() {
    this.onChange({types: []});
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentTypeMultipleSelectSection', {
    bindings: {
      types: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./agent-type-multiple-select-section.html').default,
    controller: AgentTypeMultipleSelectSectionComponent
  });
